import { render, staticRenderFns } from "./UserInbox.vue?vue&type=template&id=279b9212&scoped=true&"
import script from "./UserInbox.vue?vue&type=script&lang=ts&"
export * from "./UserInbox.vue?vue&type=script&lang=ts&"
import style0 from "./UserInbox.vue?vue&type=style&index=0&id=279b9212&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279b9212",
  null
  
)

export default component.exports